import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  error: false,
  query: [],
  ans: [],
  suggestedQuestions: [], // Store suggested questions from API
};

const queryAnsSlice = createSlice({
  name: "queryAnsSlice",
  initialState,

  reducers: {
    showLoading: (state) => {
      state.loading = true;
      state.error = false;
      console.log("showLoading called");
    },

    showError: (state) => {
      state.loading = false;
      state.error = true;
      console.log("showError called");
    },

    setQuery: (state, action) => {
      state.query = [...state.query, action.payload];
      console.log("setQuery called", state.query);
    },

    setAnswer: (state, action) => {
      state.loading = false;
      state.ans = [...state.ans, action.payload];
      console.log("setAnswer called", state.ans);
    },

    setSuggestedQuestions: (state, action) => {
      state.suggestedQuestions = [...state.suggestedQuestions, action.payload];
      console.log("setSuggestedQuestions called", state.suggestedQuestions);
    },
    stopQuery: (state) => {
      state.loading = false;
      // If the last query doesn't have an answer, mark it as stopped
      if (state.query.length > state.ans.length) {
        state.ans.push("<p style='color: #ff4d4f; font-weight: 600;'>Query stopped by user.</p>");
        state.suggestedQuestions.push([]);
      }
      console.log("stopQuery called");
    },
  },
});

export const { showLoading, showError, setQuery, setAnswer, setSuggestedQuestions, stopQuery } = queryAnsSlice.actions;
export default queryAnsSlice.reducer;
